import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import { favoritesAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';

const FavoriteButton = ({ contentId, size = 'md', showText = false }) => {
  const { isAuthenticated } = useAuth();
  const [isFavorite, setIsFavorite] = useState(false);
  const [loading, setLoading] = useState(false);

  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6'
  };

  useEffect(() => {
    if (isAuthenticated) {
      checkFavorite();
    }
  }, [contentId, isAuthenticated]);

  const checkFavorite = async () => {
    try {
      const response = await favoritesAPI.check(contentId);
      setIsFavorite(response.data.is_favorite);
    } catch (error) {
      console.error('Error checking favorite:', error);
    }
  };

  const toggleFavorite = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (!isAuthenticated) {
      alert('Please sign in to add favorites');
      return;
    }

    setLoading(true);
    try {
      if (isFavorite) {
        await favoritesAPI.remove(contentId);
        setIsFavorite(false);
      } else {
        await favoritesAPI.add(contentId);
        setIsFavorite(true);
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
    } finally {
      setLoading(false);
    }
  };

  if (showText) {
    return (
      <button
        onClick={toggleFavorite}
        disabled={loading}
        className={`flex items-center space-x-2 px-6 py-3 rounded-xl font-semibold transition-all ${
          isFavorite
            ? 'bg-electric/20 border border-electric/50 text-electric hover:bg-electric/30'
            : 'bg-white/10 border border-white/20 text-foreground hover:bg-white/20'
        } disabled:opacity-50`}
        data-testid="favorite-button"
      >
        <Heart
          className={`${sizes[size]} transition-all ${
            isFavorite ? 'fill-electric' : ''
          }`}
        />
        <span>{isFavorite ? 'In Favorites' : 'Add to Favorites'}</span>
      </button>
    );
  }

  return (
    <button
      onClick={toggleFavorite}
      disabled={loading}
      className={`p-2 rounded-lg transition-all ${
        isFavorite
          ? 'bg-electric/20 hover:bg-electric/30'
          : 'bg-white/10 hover:bg-white/20'
      } disabled:opacity-50`}
      data-testid="favorite-button"
    >
      <Heart
        className={`${sizes[size]} transition-all ${
          isFavorite ? 'text-electric fill-electric' : 'text-foreground'
        }`}
      />
    </button>
  );
};

export default FavoriteButton;
